var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalancheBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E84142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 26.6669C21.8917 26.6669 26.6673 21.8912 26.6673 16.0002C26.6673 10.1091 21.8917 5.3335 16.0007 5.3335C10.1096 5.3335 5.33398 10.1091 5.33398 16.0002C5.33398 21.8912 10.1096 26.6669 16.0007 26.6669ZM12.7777 20.8327H10.2754C9.68209 20.8327 9.38543 20.8327 9.20777 20.7177C9.01577 20.5936 8.89463 20.3853 8.88181 20.1571C8.8699 19.946 9.01683 19.6886 9.31068 19.1738L9.31081 19.1736L14.7895 9.5756C15.0876 9.05318 15.2367 8.79197 15.4265 8.69474C15.6314 8.58969 15.8744 8.58951 16.0795 8.69428C16.2694 8.79121 16.4188 9.05223 16.7178 9.57419L17.9814 11.7803L17.9814 11.7804C18.1988 12.1599 18.3075 12.3497 18.3553 12.5499C18.4073 12.7679 18.4074 12.995 18.3556 13.213C18.308 13.4132 18.1994 13.6032 17.9823 13.9829L14.7061 19.7142C14.4859 20.0995 14.3758 20.2922 14.2249 20.4362C14.0607 20.5929 13.8615 20.7085 13.6438 20.7732C13.4438 20.8327 13.2218 20.8327 12.7777 20.8327ZM21.7051 20.8327H18.804C18.2053 20.8327 17.906 20.8327 17.7278 20.7168C17.5352 20.5915 17.4144 20.3816 17.403 20.1524C17.3925 19.9403 17.5432 19.6817 17.8445 19.1649L19.2926 16.6803C19.5901 16.17 19.7389 15.9148 19.9272 15.8192C20.1308 15.7159 20.3714 15.7157 20.5751 15.8187C20.7636 15.914 20.9127 16.169 21.2109 16.6788L21.2109 16.679L22.6639 19.1635C22.9664 19.6807 23.1176 19.9393 23.1073 20.1516C23.0961 20.3811 22.9754 20.5912 22.7827 20.7166C22.6045 20.8327 22.3047 20.8327 21.7051 20.8327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalancheBadge);
export default __webpack_public_path__ + "static/media/AvalancheBadge.2657d7bf14f80a6104ba3a5fefa64dc2.svg";
export { ForwardRef as ReactComponent };